import script from "./Thankyou.vue?vue&type=script&setup=true&lang=js"
export * from "./Thankyou.vue?vue&type=script&setup=true&lang=js"

import "./Thankyou.vue?vue&type=style&index=0&id=69b19468&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b19468"]])

export default __exports__